import {helpers} from 'vuelidate/lib/validators';

/**
 * Validator for currency based amounts. Supports decimals and comma
 * separation.
 */
export default helpers.withParams({type: 'currency'}, (value) => {
    // if not empty validate
    // TODO temporary number formatting solution
    if (helpers.req(value)) {
        if (/\d,\d{3}(\.\d{1,2})?$/g.test(value)) {
            return !isNaN(Number(String(value).replace(/,/g, '')));
        }
        return !isNaN(Number(value));
    }
    return true;
});
